import { render, staticRenderFns } from "./EstadisticasDashboard.vue?vue&type=template&id=467cb434&scoped=true"
import script from "./EstadisticasDashboard.vue?vue&type=script&lang=js"
export * from "./EstadisticasDashboard.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasDashboard.vue?vue&type=style&index=0&id=467cb434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467cb434",
  null
  
)

export default component.exports